import moment from "moment"
import firebase from "firebase/compat/app"
import { toDecimal } from "src/utils/toDecimal"
import { firestore as db } from "src/Firebase"
import {
  buildInteresSnapshot,
  getBaseIdFromInteresId,
  isInteresEmbebidoId,
} from "./interesMoraService"

export const getConjuntoComprobante = (observer, Conjunto) =>
  db.collection("conjuntos").doc(Conjunto).onSnapshot(observer)

export const updateUserUnidad = (idUser, idUnidad) =>
  db.collection("usuarios").doc(idUser).update({ Casa: idUnidad })

export const getUserByConjunto = (observer, conjuntoID) =>
  db
    .collection("usuarios")
    .where("ConjuntoUidResidencia", "==", conjuntoID)
    .where("Roles.residente", "==", true)
    .onSnapshot(observer)

export const getUserByConjunto2 = conjuntoID =>
  db
    .collection("usuarios")
    .where("ConjuntoUidResidencia", "==", conjuntoID)
    .where("Roles.residente", "==", true)
    .get()

export const getInactiveResidentsByConjunto = (observer, conjuntoID) =>
  db
    .collection("usuarios")
    .where("ConjuntoUidResidencia", "==", conjuntoID)
    .where("Roles.residente", "==", false)
    .onSnapshot(observer)

export const updatePagoPendiente = (idConjunto, pagoId, data) =>
  db
    .collection("conjuntos")
    .doc(idConjunto)
    .collection("cuentasPorCobrar")
    .doc(pagoId)
    .update(data)

export const deletePagoPendiente = (idconjunto, pagoId) => {
  const ref = db
    .collection("conjuntos")
    .doc(idconjunto)
    .collection("cuentasPorCobrar")
  if (isInteresEmbebidoId(pagoId)) {
    return ref
      .doc(getBaseIdFromInteresId(pagoId))
      .update({ Interes: firebase.firestore.FieldValue.delete() })
  }
  return ref.doc(pagoId).delete()
}

export const newPagoPendiente = (conjuntoId, data) =>
  db
    .collection("conjuntos")
    .doc(conjuntoId)
    .collection("cuentasPorCobrar")
    .add({
      Nombre: data.Nombre,
      Valor: toDecimal(data.Valor * 1),
      DescuentoProntoPago: data.DescuentoProntoPago
        ? toDecimal(data.DescuentoProntoPago * 1)
        : 0,
      TipoDescuentoProntoPago: data.TipoDescuentoProntoPago || "valor",
      FechaLimite: new Date(data.FechaLimite),
      FechaRegistro: new Date(),
      Descripcion: data.Descripcion,
      UsuarioId: data.UsuarioId,
      NombreUsuario: data.NombreUsuario,
      CasaUsuario: data.CasaUsuario,
      Rubro: data.Rubro,
      SubRubro: data.SubRubro,
      ValorOriginal: toDecimal(data.Valor * 1),
    })

const pendingInteresConfig = new Map()
const getConfigInteresesCompartida = conjuntoId => {
  if (!pendingInteresConfig.has(conjuntoId)) {
    const request = db
      .collection("conjuntos")
      .doc(conjuntoId)
      .collection("conjuntoConfig")
      .doc("Intereses")
      .get()
      .then(snapshot => (snapshot.exists ? snapshot.data() : {}))
      .finally(() => pendingInteresConfig.delete(conjuntoId))
    pendingInteresConfig.set(conjuntoId, request)
  }
  return pendingInteresConfig.get(conjuntoId)
}

// interes se guarda como map dentro de la cxcBase
export const createCxcInteres = async (conjuntoId, data) => {
  const configIntereses = await getConfigInteresesCompartida(conjuntoId)
  return db
    .collection("conjuntos")
    .doc(conjuntoId)
    .collection("cuentasPorCobrar")
    .doc(data.CuentaBaseId)
    .update({
      Interes: {
        Nombre: data.Nombre,
        Descripcion: data.Descripcion,
        FechaInicioMora: new Date(data.FechaInicioMora),
        FechaUltimoCorte: new Date(data.FechaInicioMora),
        CapitalBaseRemanente: toDecimal(data.CapitalBaseRemanente * 1),
        InteresAcumuladoCausado: 0,
        InteresAcumuladoPagado: 0,
        UltimoMesFacturado: 0,
        EstadoPago: "Pendiente",
        ...buildInteresSnapshot(configIntereses),
      },
    })
}

export const updateUltimaExpensaConjunto = (idConjunto, UltimoMesAlicuota) =>
  db.collection("conjuntos").doc(idConjunto).update({
    UltimoMesAlicuota,
  })

// FIXIT: Buscar al usuario por nombre, apellido, cedula. Ya no por correo
export const getUser = (userName, userLast, userDNI) =>
  db
    .collection("usuarios")
    .where("Cedula", "==", userDNI)
    .where("Nombre", "==", userName)
    .where("Apellido", "==", userLast)
    .get()

export const getUnidadesHab = (conjuntoID, observer) =>
  db
    .collection("conjuntos")
    .doc(conjuntoID)
    .collection("unidadesHabitacionales")
    .onSnapshot(observer)

export const suscriberReceivables = (conjuntoUid, userId, casaId, observer) =>
  db
    .collection("conjuntos")
    .doc(conjuntoUid)
    .collection("cuentasPorCobrar")
    .where("UsuarioId", "==", userId)
    .where("CasaUsuario", "==", casaId)
    .orderBy("FechaLimite")
    .onSnapshot(observer)

export const getUsuariosMorososSinCasa = (conjuntoUid, userId, observer) =>
  db
    .collection("conjuntos")
    .doc(conjuntoUid)
    .collection("cuentasPorCobrar")
    .where("UsuarioId", "==", userId)
    .orderBy("FechaLimite")
    .onSnapshot(observer)

export const getPendingPays = (conjuntoUid, user) =>
  db
    .collection("conjuntos")
    .doc(conjuntoUid)
    .collection("cuentasPorCobrar")
    .where("UsuarioId", "==", user)
    .where("FechaLimite", "<=", moment().endOf("month").toDate())
    .get()

export const getPendingPaysMonth = (conjuntoUid, user, desde, hasta) =>
  db
    .collection("conjuntos")
    .doc(conjuntoUid)
    .collection("cuentasPorCobrar")
    .where("UsuarioId", "==", user)
    .where("FechaLimite", ">=", desde)
    .where("FechaLimite", "<=", hasta)
    .get()

export const getSaldoFavor = (conjuntoUid, user) =>
  db
    .collection("conjuntos")
    .doc(conjuntoUid)
    .collection("ingresos")
    .where("Usuario", "==", user)
    .where("esAnticipoCuentas", "==", true)
    .get()

export const getRubros = (conjuntoUid, tipo) =>
  db
    .collection("conjuntos")
    .doc(conjuntoUid)
    .collection("rubros")
    .where("Tipo", "==", tipo)
    .get()

export const getSubRubros = (conjuntoUid, Rubroid) =>
  db
    .collection("conjuntos")
    .doc(conjuntoUid)
    .collection("rubros")
    .doc(Rubroid)
    .get()
export const getSubconjuntos = (idConjunto, observer) =>
  db
    .collection("conjuntos")
    .doc(idConjunto)
    .collection("conjuntoConfig")
    .doc("Subconjuntos")
    .onSnapshot(observer)

export const updateUsuario = (idUser, data) =>
  db.collection("usuarios").doc(idUser).update({
    Familia: data,
  })

export const updateCorreo = (idUser, data) =>
  db.collection("usuarios").doc(idUser).update({
    CorreosNotificacion: data,
  })

export const updateUser = (userid, data) =>
  db.collection("usuarios").doc(userid).update({
    Roles: data,
  })

export const getModulos = (observer, idConjunto) =>
  db
    .collection("conjuntos")
    .doc(idConjunto)
    .collection("conjuntoConfig")
    .doc("Modulos")
    .onSnapshot(observer)

/* Grupos */
export const updateMiembroGrupo = (idresidente, Grupos) =>
  db.collection("usuarios").doc(idresidente).update({ Grupos })

export const updateMiembrosGrupoBatch = async updates => {
  const batch = db.batch()
  const userPromises = updates.map(({ id }) =>
    db.collection("usuarios").doc(id).get()
  )
  const userDocs = await Promise.all(userPromises)

  updates.forEach(({ id, grupos }, index) => {
    const ref = db.collection("usuarios").doc(id)
    const userData = userDocs[index].data()
    const gruposExistentes = userData?.Grupos || []
    const gruposFinales = [...gruposExistentes]

    grupos.forEach(grupo => {
      const grupoNormalizado = grupo.toLowerCase().trim()
      const yaExiste = gruposExistentes.some(
        existente => existente.toLowerCase().trim() === grupoNormalizado
      )
      if (!yaExiste) {
        gruposFinales.push(grupo)
      }
    })

    batch.update(ref, { Grupos: gruposFinales })
  })
  await batch.commit()
}

// Autorizados
export const updateListaAprobadores = (idUser, data) =>
  db.collection("usuarios").doc(idUser).update({
    Aprobadores: data,
  })
